import { executeRequest, JFSRequest } from '@jfs/network'
import { RootStore } from '../data/store'
import { formatDate, isSuccessResponse, removeEmpty } from '../utils'
import { ApprovalTypes } from '../utils/constants'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any, type: any) => {
  const data = isSuccessResponse(response)

  const retData = {
    ...data,
    content: parseContent(data?.content, type),
  }
  return retData
}

const parseContent = (content, type) => {
  return content?.map((item: any) =>  getResponseDataParser(type)(item))
}

const getMasterPendingApprovals = (elevated: boolean, body: any, type: string) => {
  const request: JFSRequest<{}> = {
    apiPath: `${getUrl(getApprovalApi(type))}?elevated=${elevated}`,
    method: 'POST',
    cache: false,
    config: sitConfig(RootStore.session.getTokens),
    headers: getHeaders(),
    body: body,
  }

  return executeRequest(request)
    .then((data) => responseParser(data, type))
    .catch((error) => {
      throw error
    })
}

export const getCommanApprovalReq = (data: any, paginationInfo: any) => {
  data = removeEmpty(data)
  console.log('data', data)
  return {
    inputFilter: data,
    configParams: paginationInfo,
  }
}

const getApprovalApi = (type: string) => {
  const getTypeData = {
    [ApprovalTypes.ENTITY]: APIEndPoints.entityMasterApprovals,
    [ApprovalTypes.CARDMAPPING]: APIEndPoints.cardMappingApprovals,
    [ApprovalTypes.NETBANKING]: APIEndPoints.nBMappingApprovals,
    [ApprovalTypes.MERCHANT]: APIEndPoints.merchantMappingPendingApprovals,
    [ApprovalTypes.FILE_ROUTING]: APIEndPoints.routingFileApproval,
    [ApprovalTypes.PACKAGE]: APIEndPoints.routingPendingApprovals,
    [ApprovalTypes.PACKAGE_INSTRUMENT]: APIEndPoints.routingPack2InstPendingApprovals,
    [ApprovalTypes.PACKAGE_MID]: APIEndPoints.routingMid2PackPendingApprovals,
    [ApprovalTypes.BANKING_CODE]: APIEndPoints.pendingApprovalsOfBankingCodes,
    [ApprovalTypes.GENERATE_EXCEL_FILE]: APIEndPoints.pendingApprovalsOfFiles,
    [ApprovalTypes.FEE_PACKAGE]: APIEndPoints.routingPendingApprovals,
    [ApprovalTypes.FEE_PACKAGE_FILE_UPLOAD]: APIEndPoints.routingFileApproval,
    [ApprovalTypes.FEE_PACKAGE_MID]: APIEndPoints.routingMid2PackPendingApprovals,
    [ApprovalTypes.MERCHANT_PAYOUT]: APIEndPoints.riskControlMerchantPendingApprovals,
    [ApprovalTypes.CREDIT_ADJUSTMENT]: APIEndPoints.crDrAdjudtmentPendingApprovals,
    [ApprovalTypes.RISK_CONFIG_MID]: APIEndPoints.riskControlMerchantPendingApprovals,
    [ApprovalTypes.PAYOUT_CMS]: APIEndPoints.payoutCmsPendingApprovals,
    [ApprovalTypes.RISK_CONFIG_TXNS]: APIEndPoints.riskControlTxnPendingApprovals,
  }
  return getTypeData[type] ?? APIEndPoints.entityMasterApprovals
}


const getResponseDataParser = (type: string) => {
  const getParser = {
    [ApprovalTypes.CARDMAPPING]: getCardMappingParser,
    [ApprovalTypes.NETBANKING]: getNetBankingParser,
    [ApprovalTypes.MERCHANT]: getMerchantListParser,
    [ApprovalTypes.FILE_ROUTING]: getFileRoutingApprovalParser,
    [ApprovalTypes.PACKAGE]: getPackageListParser,
    [ApprovalTypes.PACKAGE_MID]: getPackageMidParser,
    [ApprovalTypes.BANKING_CODE]: getBankingListParser,
    [ApprovalTypes.GENERATE_EXCEL_FILE]: getGenerateExcelParser,
    [ApprovalTypes.FEE_PACKAGE]: getPackageListParser,
    [ApprovalTypes.FEE_PACKAGE_FILE_UPLOAD]: getFileRoutingApprovalParser,
    [ApprovalTypes.FEE_PACKAGE_MID]: getPackageMidParser,
    [ApprovalTypes.MERCHANT_PAYOUT]: getMerchantPayoutParser,
    [ApprovalTypes.CREDIT_ADJUSTMENT]: getCreditAdjustmentParser,
    [ApprovalTypes.RISK_CONFIG_MID]: getRiskConfigMidParser,
    [ApprovalTypes.PAYOUT_CMS]:getPayoutCmsParser,
    [ApprovalTypes.RISK_CONFIG_TXNS]: getRiskConfigTnxParser,
  }
  return getParser[type] ?? getDefaultParser
}

const getCardMappingParser=(item:any)=>({
  id: item?.id,
  key: item?.key,
  data: {
    type: 'card',
    entityId: item?.object?.entityId,
    scheme: item?.object?.scheme,
    cardType: item?.object?.cardType,
    status: item?.object?.status,
    id: item?.key,
  },
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getNetBankingParser=(item:any)=>({
  id: item?.id,
  key: item?.key,
  approvalStatus: item?.approvalStatus,
  username: item?.username,
  approvalType: item?.approvalType,
  className: item?.approvalType,
  type: item?.type,
  data: {
    type: 'netbank',
    id: item?.object?.id?.toString() ?? '',
    entityId: item?.object?.entityId,
    entityCode: item?.object?.entityCode,
    rpslCode: item?.object?.rpslCode,
    bankName: item?.object?.bankName,
    status: item?.object?.status,
  },
})

const getMerchantListParser=(item:any)=>({
  id: item?.id,
  key: item?.key,
  approvalStatus: item?.approvalStatus,
  username: item?.username,
  approvalType: item?.approvalType,
  className: item?.className,
  type: item?.type,
  data: {
    type: 'merchant',
    id: item?.object?.id?.toString() ?? '',
    merchantId: item?.object?.merchantId ?? '',
    entityId: item?.object?.entityId,
    txnType: item?.object?.txnType,
    instrumentType: item?.object?.instrumentType,
    reqType: item?.object?.reqType ?? '',
    meCode: item?.object?.meCode ?? '',
    pgSecurityId: item?.object?.pgSecurityId ?? '',
    secret: item?.object?.secret ?? '',
    chiper: item?.object?.chiper ?? '',
    mcfg1: item?.object?.mcfg1 ?? '',
    mcfg2: item?.object?.mcfg2 ?? '',
    mappingStatus: item?.object?.mappingStatus ? 'true' : 'false',
  },
})

const getFileRoutingApprovalParser = (item:any)=>({
  id: item?.id,
  key: item?.key ?? '',
  type: item?.type ?? '',
  className: item?.className ?? '',
  username: item?.username ?? '',
  approvalType: item?.approvalType ?? '',
  approvalStatus: item?.approvalStatus ?? '',
  data: {
    type: 'FileUpload',
  
  },
  fileUploadData: {
    id: item?.id,
    fileName: item?.object?.savedFileName,
    link: item?.object?.filePath,
    createdDate: formatDate(item?.createdDate),
    fileType: filetype(item),
  },
})

const filetype = (item:any) => {
  const originalArr = item?.object?.originalFileName?.split('.')
  return originalArr?.[originalArr.length - 1] ?? 'xls'
}

const getPackageListParser=(item:any)=>({
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
  className: item?.className,
  id: item?.id,
  key: item?.key,
  type: item?.type,
  username: item?.username,
  data: {
    type: 'package',
    id: item?.object?.id,
    group: item?.object?.group,
    category: item?.object?.category,
    packageName: item?.object?.packageName,
  },
})

const getPackageMidParser=(item:any)=>({
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
  className: item?.className,
  id: item?.id,
  key: item?.key,
  type: item?.type,
  username: item?.username,
  data: {
    type: 'package2MId',
    id: item?.object?.id,
    mid: item?.object?.mid,
    packageName: item?.object?.packageName,
  },
})

const getBankingListParser=(item:any)=>({
  id: item?.id,
  key: item?.key,
  bankingCodeData: {
    id: !isNaN(Number(item?.key)) ? Number(item?.key) : undefined,
    code: item?.object?.code,
    name: item?.object?.name,
    type: item?.object?.type,
    status: item?.object?.status ? 'true' : 'false',
    description: item?.object?.description,
    extraField1: item?.object?.extraField1,
    extraField2: item?.object?.extraField2,
  },
  data: {},
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getGenerateExcelParser=(item:any)=>({
  id: item?.id,
  key: item?.key,
  data: {
    type: 'excelFile',
    id: '' + item?.object?.packageId,
    fileName: item?.object?.fileName ?? '',
    rules: item?.object?.rules ?? '',
  },
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getMerchantPayoutParser=(item:any)=>({
  id: item?.id,
  key: item?.key,
  merchantPayoutData: {
    mid: item?.object?.entity?.entityId,
    frequencyId: '' + item?.object?.payoutConfig?.frequencyId,
    autoSettle: item?.object?.payoutConfig?.autoSettle === 0 ? false : true,
    autoSettleDays: '' + item?.object?.payoutConfig?.autoSettleDays ?? '',
    settlementOnHold: item?.object?.payoutConfig?.payoutSettleHold === 0 ? false : true,
    isDynamicSettlement: item?.object?.payoutConfig?.checker === 0 ? false : true,
    remarks: item?.object?.payoutConfig?.remarks ?? '',
  },
  data: {},
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getRiskConfigMidParser= (item:any)=>({
  id: item?.id,
  key: item?.key ?? 'NA',
  data: {
    id: !isNaN(Number(item?.id)) ? Number(item?.id) : undefined,
    entityId: item?.object?.entity?.entityId,
    amount: `${item?.object?.amount?.netAmount ?? 'NA'}`,
    invoice: item?.object?.invoice,
    methodType: item?.object?.method?.type,
    methodSubType: item?.object?.method?.subType,
    originalId: item?.object?.originalId,
    description: item?.object?.statementDescriptor ?? 'NA',
  },
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getCreditAdjustmentParser=(item:any)=>({
  id: item?.id,
  key: item?.key ?? 'NA',
  crDrAdjustmentData: {
    id: !isNaN(Number(item?.id)) ? Number(item?.id) : undefined,
    entityId: item?.object?.entity?.entityId,
    amount: `${item?.object?.amount?.netAmount ?? 'NA'}`,
    invoice: item?.object?.invoice,
    methodType: item?.object?.method?.type,
    methodSubType: item?.object?.method?.subType,
    originalId: item?.object?.originalId,
    description: item?.object?.statementDescriptor ?? 'NA',
  },
  data: {},
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getPayoutCmsParser=(item:any)=>({
  id: item?.id,
  key: item?.key ?? 'NA',
  settlement: {
    id: !isNaN(Number(item?.id)) ? Number(item?.id) : undefined,
    entityId: item?.object?.entity?.entityId,
    amount: item?.object?.amount?.netAmount,
    invoice: item?.object?.invoice,
    methodType: item?.object?.method?.type,
    methodSubType: item?.object?.method?.subType,
    originalId: item?.object?.originalId,
    description: item?.object?.statementDescriptor,
    transactionId: item?.object?.updateParameters?.transactionId,
    status: item?.object?.payout?.status,
    externalReferenceNumber: item?.object?.payout?.externalReferenceNumber,
    payoutDate: item?.object?.payout?.payoutDate,
    requestType: item?.object?.requestType,
  },
  data: {},
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getRiskConfigTnxParser=(item:any)=>({
  id: item?.id,
  key: item?.key ?? 'NA',
  data: {
    id: !isNaN(Number(item?.id)) ? Number(item?.id) : undefined,
    entityId: item?.object?.entity?.entityId,
    amount: `${item?.object?.amount?.netAmount ?? 'NA'}`,
    invoice: item?.object?.invoice,
    methodType: item?.object?.method?.type,
    methodSubType: item?.object?.method?.subType,
    originalId: item?.object?.originalId,
    description: item?.object?.statementDescriptor ?? 'NA',
  },
  type: item?.type,
  className: item?.className,
  username: item?.username,
  approvalStatus: item?.approvalStatus,
  approvalType: item?.approvalType,
})

const getDefaultParser=(item:any)=>({
  id: item?.id ?? '',
  key: item?.key ?? '',
  data: {
    id: item?.object?.id,
    name: item?.object?.name,
    type: item?.object?.type,
    status: item?.object?.status,
    supportNetBanking: item?.object?.supportNetBanking,
    supportCard: item?.object?.supportCard,
    contacts: item?.object?.contactPDetails,
    publicIps: item?.object?.publicIp,
    endpointInfo: {
      domain: item?.object?.endpointDomain,
      status: item?.object?.endpointStatus,
      checksumEncryptionSelect: item?.object?.checksumEncryptionSelect,
      encryptionType: item?.object?.encryptionType,
      redirectUrl: item?.object?.entityRedirectURL,
      enrollUrl: item?.object?.entityEnrollURL,
      authUrl: item?.object?.entityAuthURL,
      stqUrl: item?.object?.entityStqURL,
      s2sUrl: item?.object?.entityS2SURL,
      rpslS2sUrl: item?.object?.rpslS2SURL,
    },
    updatedBy: item?.object?.updatedBy,
    createdDate: '' + item?.object?.createdDate,
    updatedDate: '' + item?.object?.updatedDate,
  },
  type: item?.type ?? '',
  className: item?.className ?? '',
  username: item?.username ?? '',
  approvalType: item?.approvalType ?? '',
  approvalStatus: item?.approvalStatus ?? '',
})
export { getMasterPendingApprovals }
